import { render, staticRenderFns } from "./fixed-header.vue?vue&type=template&id=58df3ac0&scoped=true"
import script from "./fixed-header.vue?vue&type=script&lang=js"
export * from "./fixed-header.vue?vue&type=script&lang=js"
import style0 from "./fixed-header.vue?vue&type=style&index=0&id=58df3ac0&prod&lang=scss&scoped=true"
import style1 from "./fixed-header.vue?vue&type=style&index=1&id=58df3ac0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58df3ac0",
  null
  
)

export default component.exports